function ContentOverlayService() {
    this.isOpen = false;
}

ContentOverlayService.prototype.open = function (callback, cssClass) {
    this.cssClass = cssClass || '';
    this.isOpen = true;
    this.callback = callback;
};

ContentOverlayService.prototype.close = function () {
    this.isOpen = false;
};

module.exports = ContentOverlayService;



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/contentoverlay/content-overlay-service.js
 **/